import {ConnectedRouter} from 'connected-react-router';
import {createBrowserHistory} from 'history';
import React from 'react';
import ReactDom from 'react-dom';
import {Provider} from 'react-redux';
import {Route, Switch} from 'react-router';
import sugar from 'sugar';

import {injectAppGlobalStyles} from './components/globalStyles';
import PrivateRoute from './components/privateRoute';
import PreloadStateService from './logic/preloadStateService';
import {AppRouteToPath} from './logic/routes';
import {RootState, setupStore} from './logic/store';
import * as AuthenticationStore from './logic/store/authenticationStore';
import trackingService from './logic/trackingService';
import * as serviceWorker from './serviceWorker';
import AboutUsPageView from './views/aboutUsPageView';
import CloudAnalyticsPageView from './views/cloudAnalyticsPageView';
import DemoDetailPageView from './views/demoDetailPageView';
import EncodingPageView from './views/encodingPageView/encodingPageView';
import LandingPageView from './views/landingPageView';
import LiveEncodingPageView from './views/liveEncodingPageView';
import LoginPageView from './views/loginPageView';
import OnPremiseAnalyticsPageView from './views/onPremiseAnalyticsPageView/onPremiseAnalyticsPageView';
import OnPremiseEncodingPageView from './views/onPremiseEncodingPageView/onPremiseEncodingPageView';
import PlaybackPageView from './views/playbackPageView/playbackPageView';
import PlayerPageView from './views/playerPageView/playerPageView';

sugar.extend();

injectAppGlobalStyles();

PreloadStateService.fetchPreloadState().then((preloadState: RootState | undefined) => {
  const history = createBrowserHistory();
  const store = setupStore(history, preloadState);

  if (store.getState().authentication.status !== AuthenticationStore.AuthenticationStatus.Offline) {
    store.dispatch(AuthenticationStore.loginWithLocalStorageApiKey() as any);
  }

  trackingService.init();
  trackingService.logOpen();

  ReactDom.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path={AppRouteToPath.Login} exact={true} component={LoginPageView} />

          <PrivateRoute path={AppRouteToPath.CloudAnalytics} exact={true} component={CloudAnalyticsPageView} />
          <PrivateRoute path={AppRouteToPath.Encoding} exact={true} component={EncodingPageView} />
          <PrivateRoute path={AppRouteToPath.LiveEncoding} exact={true} component={LiveEncodingPageView} />
          <PrivateRoute path={AppRouteToPath.OnPremiseAnalytics} exact={true} component={OnPremiseAnalyticsPageView} />
          <PrivateRoute path={AppRouteToPath.OnPremiseEncoding} exact={true} component={OnPremiseEncodingPageView} />
          <PrivateRoute path={AppRouteToPath.Playback} exact={true} component={PlaybackPageView} />
          <PrivateRoute path={AppRouteToPath.Player} exact={true} component={PlayerPageView} />
          <PrivateRoute path={AppRouteToPath.DemoDetail} exact={true} component={DemoDetailPageView} />
          <PrivateRoute path={AppRouteToPath.AboutUs} exact={true} component={AboutUsPageView} />

          <PrivateRoute path={AppRouteToPath.Root} component={LandingPageView} />
        </Switch>
      </ConnectedRouter>
    </Provider>,
    document.querySelector('#root')
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
